var render, staticRenderFns
import script from "./HomeBackground.vue?vue&type=script&lang=tsx"
export * from "./HomeBackground.vue?vue&type=script&lang=tsx"
import style0 from "./HomeBackground.vue?vue&type=style&index=0&id=bd861bf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd861bf8",
  null
  
)

export default component.exports